import { render, staticRenderFns } from "./resetPwd.vue?vue&type=template&id=fa81fa50&scoped=true"
import script from "./resetPwd.vue?vue&type=script&lang=ts"
export * from "./resetPwd.vue?vue&type=script&lang=ts"
import style0 from "./resetPwd.vue?vue&type=style&index=0&id=fa81fa50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa81fa50",
  null
  
)

export default component.exports